export const MAX_ALLOWED_ACTIVE_CUSTOM_ORDER_FILTERS = 20;
